import {
  COLORS,
  INSTALL_BANNER_HEIGHT,
  Z_INDEXES,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';

const INSTALL_BANNER_HEIGHT_IN_PX = `${INSTALL_BANNER_HEIGHT}px`;

export const AppInstallBannerStyle = {
  bottomOffsetCssVariable: '--install-banner-margin-bottom',
  bottomOffsetWhenHidden: `-${INSTALL_BANNER_HEIGHT_IN_PX}`,
  bottomOffsetWhenShown: '0px',
};

export const HeaderInstallBannerWrapper = styled.div<{$empty?: boolean}>`
  height: ${({$empty}) => ($empty ? 0 : INSTALL_BANNER_HEIGHT_IN_PX)};
  margin-bottom: var(${AppInstallBannerStyle.bottomOffsetCssVariable});
  transform: translateY(var(${AppInstallBannerStyle.bottomOffsetCssVariable}));
  position: relative;
  z-index: ${Z_INDEXES.APP_INSTALL_BANNER};
  background: ${COLORS.White};
`;
